module.exports = __webpack_public_path__ + "static/img/vab.08120a30.svg";